var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgencyPortal = function SvgAgencyPortal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BFB5FF",
    clipPath: "url(#agency-portal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.4A5.2 5.2 0 1 0 12 0a5.2 5.2 0 0 0 0 10.4M0 24c0-6.63 5.37-12 12-12s12 5.37 12 12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "agency-portal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgAgencyPortal as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE2MjY5XzM2NDIpIj4KPHBhdGggZD0iTTEyIDEwLjRDMTQuODcxOSAxMC40IDE3LjIgOC4wNzE4OCAxNy4yIDUuMkMxNy4yIDIuMzI4MTIgMTQuODcxOSAwIDEyIDBDOS4xMjgxMSAwIDYuNzk5OTkgMi4zMjgxMiA2Ljc5OTk5IDUuMkM2Ljc5OTk5IDguMDcxODggOS4xMjgxMSAxMC40IDEyIDEwLjRaIiBmaWxsPSIjQkZCNUZGIi8+CjxwYXRoIGQ9Ik0wIDI0QzAgMTcuMzcgNS4zNyAxMiAxMiAxMkMxOC42MyAxMiAyNCAxNy4zNyAyNCAyNCIgZmlsbD0iI0JGQjVGRiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE2MjY5XzM2NDIiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";